export interface AccessRow {
  format: string;
  content: string;
  pages: string;
}

export const accessRows: AccessRow[] = [
  { format: '📖 PDF imprimible', content: '11 tomos, de 1º de Primaria a 1º de Bachillerato', pages: '739 páginas' },
  { format: '💪 PDF imprimible', content: '4 bonos de apoyo', pages: '75 páginas A4' }
];

export const accessChecks: string[] = [
  'PDF de alta calidad',
  'Imprimible en A4',
  'Optimizado para móviles y tabletas',
  'Acceso inmediato sin esperas'
];
